import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserDashboardcardsComponent } from './user-dashboardcards.component';
import { ProgressModule } from '../../../@hornbillfx/components/progress/progress.module';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CourseFilterPipe } from './course-filter.pipe';
import { SharedModule } from '../../../@hornbillfx/components/shared.module';
import { D3Service } from 'd3-ng2-service';
import { LearnerStatusChartComponent } from './charts/learner-status-chart/learner-status-chart.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { pgTabsModule } from '../../../@hornbillfx/components/tabs/tabs.module';
import { pgCollapseModule } from '../../../@hornbillfx/components/collapse';
import { pgCardModule } from '../../../@hornbillfx/components/card/card.module';
import { QuizReviewComponent } from './charts/quiz-review/quiz-review.component';
import { QuizReviewService } from './charts/quiz-review/quiz-review.service';

@NgModule({
  imports: [
    CommonModule,
    ProgressModule,
    RouterModule,
    FormsModule,
    SharedModule,
    pgTabsModule,
    pgCollapseModule,
    pgCardModule

  ],
  declarations: [
    UserDashboardcardsComponent,
    CourseFilterPipe,
    LearnerStatusChartComponent,
    QuizReviewComponent

  ],
  exports:[QuizReviewComponent],
  providers: [D3Service, NgbModal, QuizReviewService]
})
export class UserDashboardcardsModule { }



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/user-module/user-dashboard/user-dashboardcards/user-dashboardcards.module.ts